export default {
    // @特殊命令
    'JS実行': {
        type: 'func',
        josi: [['を', 'で']],
        pure: true,
        fn: function (src, sys) {
            return sys.__evalJS(src, sys); // #1733
        }
    },
    'JSオブジェクト取得': {
        type: 'func',
        josi: [['の']],
        pure: false,
        fn: function (name, sys) {
            return sys.__findVar(name, null);
        }
    },
    'JS関数実行': {
        type: 'func',
        josi: [['を'], ['で']],
        fn: function (name, args, sys) {
            // nameが文字列ならevalして関数を得る
            if (typeof name === 'string') {
                name = sys.__evalJS(name, sys);
            }
            if (typeof name !== 'function') {
                throw new Error('JS関数取得で実行できません。');
            }
            // argsがArrayでなければArrayに変換する
            if (!(args instanceof Array)) {
                args = [args];
            }
            // 実行
            // eslint-disable-next-line prefer-spread
            return name.apply(null, args);
        }
    },
    'ASYNC': {
        type: 'func',
        josi: [],
        asyncFn: true,
        pure: true,
        fn: async function () {
            // empty
        },
        return_none: true
    },
    'AWAIT実行': {
        type: 'func',
        josi: [['を'], ['で']],
        pure: true,
        asyncFn: true,
        fn: async function (f, args, sys) {
            // nameが文字列ならevalして関数を得る
            if (typeof f === 'string') {
                f = sys.__findFunc(f, 'AWAIT実行');
            }
            if (!(f instanceof Function)) {
                throw new Error('『AWAIT実行』の第一引数はなでしこ関数名かFunction型で指定してください。');
            }
            // argsがArrayでなければArrayに変換する
            if (!(args instanceof Array)) {
                args = [args];
            }
            // 実行
            return await f(...args);
        }
    },
    'JSメソッド実行': {
        type: 'func',
        josi: [['の'], ['を'], ['で']],
        fn: function (obj, m, args, sys) {
            // objが文字列ならevalして関数を得る
            if (typeof obj === 'string') {
                obj = sys.__evalJS(obj, sys);
            }
            if (typeof obj !== 'object') {
                throw new Error('JSオブジェクトを取得できませんでした。');
            }
            // method を求める
            if (typeof m !== 'function') {
                m = obj[m];
            }
            // argsがArrayでなければArrayに変換する
            if (!(args instanceof Array)) {
                args = [args];
            }
            // 実行
            return m.apply(obj, args);
        }
    },
    'ナデシコ': {
        type: 'func',
        josi: [['を', 'で']],
        pure: false,
        asyncFn: true,
        fn: async function (code, sys) {
            const options = {
                resetEnv: false,
                resetAll: true,
                nakoGlobal: sys
            };
            const tmpLog = String(sys.__getSysVar('表示ログ', ''));
            sys.__setSysVar('表示ログ', '');
            await sys.__self.runAsync(code, sys.__modName, options);
            const outLog = String(sys.__getSysVar('表示ログ'));
            sys.__setSysVar('表示ログ', tmpLog + outLog);
            return outLog;
        }
    },
    'ナデシコ続': {
        type: 'func',
        josi: [['を', 'で']],
        pure: false,
        asyncFn: true,
        fn: async function (code, sys) {
            const options = {
                resetEnv: false,
                resetAll: false,
                nakoGlobal: sys.__self
            };
            const tmpLog = sys.__getSysVar('表示ログ', '');
            sys.__setSysVar('表示ログ', '');
            await sys.__self.runAsync(code, sys.__modName, options);
            const outLog = String(sys.__getSysVar('表示ログ'));
            if (outLog) {
                sys.logger.trace(outLog);
            }
            sys.__setSysVar('表示ログ', tmpLog + outLog);
            return outLog;
        }
    },
    '実行': {
        type: 'func',
        josi: [['を', 'に', 'で']],
        pure: false,
        fn: function (f, sys) {
            // #938 の規則に従って処理
            // 引数が関数なら実行
            if (typeof f === 'function') {
                return f(sys);
            }
            // 文字列なら関数に変換できるか判定して実行
            if (typeof f === 'string') {
                const tf = sys.__findFunc(f, '実行');
                if (typeof tf === 'function') {
                    return tf(sys);
                }
            }
            // それ以外ならそのまま値を返す
            return f;
        }
    },
    '実行時間計測': {
        type: 'func',
        josi: [['の']],
        pure: false,
        fn: function (f, sys) {
            if (typeof f === 'string') {
                f = sys.__findFunc(f, '実行時間計測');
            }
            //
            if (typeof performance !== 'undefined' && performance.now) {
                const t1 = performance.now();
                f(sys);
                const t2 = performance.now();
                return (t2 - t1);
            }
            else {
                const t1 = Date.now();
                f(sys);
                const t2 = Date.now();
                return (t2 - t1);
            }
        }
    },
    '終': {
        type: 'func',
        josi: [],
        pure: true,
        fn: function (sys) {
            // デバッグモードでなければ例外を投げることでプログラムを終了させる
            sys.__setSysVar('__forceClose', true);
            if (!sys.__getSysVar('__useDebug')) {
                throw new Error('__終わる__');
            }
        }
    },
    // @デバッグ支援
    'デバッグ表示': {
        type: 'func',
        josi: [['と', 'を', 'の']],
        pure: true,
        fn: function (s, sys) {
            // 行番号の情報を得る
            const lineInfo = String(sys.__getSysVar('__line', 0)) + '::';
            const a = lineInfo.split(':', 2);
            const no = parseInt(String(a[0]).replace('l', '')) + 1;
            const fname = a[1];
            // オブジェクトならJSON文字列に変換
            if (typeof s === 'object') {
                s = JSON.stringify(s);
            }
            s = `${fname}(${no}): ${s}`;
            sys.__exec('表示', [s, sys]);
        },
        return_none: true
    },
    'ハテナ関数設定': {
        type: 'func',
        josi: [['を', 'の']],
        pure: true,
        fn: function (s, sys) {
            if (typeof s === 'function') {
                sys.__hatena = s;
                return;
            }
            if (typeof s === 'string') {
                sys.__hatena = sys.__getSysVar(s, 'デバッグ表示');
                return;
            }
            if (s instanceof Array) {
                const fa = s.map((fstr) => {
                    if (fstr.substring(0, 3) === 'JS:') {
                        const code = fstr.substring(3);
                        return sys.__evalJS(code, sys);
                    }
                    else {
                        return sys.__getSysVar(fstr, 'デバッグ表示');
                    }
                });
                sys.__hatena = (p, sys) => {
                    let param = p;
                    for (const f of fa) {
                        param = f(param, sys);
                    }
                };
                return;
            }
            sys.__hatena = sys.__getSysVar('デバッグ表示');
        },
        return_none: true
    },
    'ハテナ関数実行': {
        type: 'func',
        josi: [['の', 'を', 'と']],
        pure: true,
        fn: function (s, sys) {
            sys.__hatena(s, sys);
        },
        return_none: true
    },
    'エラー発生': {
        type: 'func',
        josi: [['の', 'で']],
        pure: true,
        fn: function (s) {
            throw new Error(s);
        },
        return_none: true
    },
    '__DEBUG': {
        type: 'func',
        josi: [],
        pure: true,
        fn: function (sys) {
            sys.isDebug = true;
            console.log(sys);
        }
    },
    '__DEBUG強制待機': { type: 'const', value: 0 }, // @__DEBUGきょうせいたいき
    '__DEBUGブレイクポイント一覧': { type: 'const', value: [] }, // @__DEBUGぶれいくぽいんといちらん
    '__DEBUG待機フラグ': { type: 'const', value: 0 }, // @__DEBUGたいきふらぐ
    '__DEBUG_BP_WAIT': {
        type: 'func',
        josi: [['で']],
        pure: true,
        asyncFn: true,
        fn: function (curLine, sys) {
            return new Promise((resolve) => {
                const breakpoints = sys.__getSysVar('__DEBUGブレイクポイント一覧');
                const forceLine = sys.__getSysVar('__DEBUG強制待機');
                sys.__setSysVar('__DEBUG強制待機', 0);
                // ブレイクポイント or __DEBUG強制待機 が指定されたか？
                if (breakpoints.indexOf(curLine) >= 0 || forceLine) {
                    if (sys.__getSysVar('プラグイン名') !== 'メイン') {
                        return;
                    } // 現状メインのみデバッグする
                    console.log(`@__DEBUG_BP_WAIT(${curLine})`);
                    const timerId = setInterval(() => {
                        if (sys.__getSysVar('__DEBUG待機フラグ') === 1) {
                            sys.__setSysVar('__DEBUG待機フラグ', 0);
                            clearInterval(timerId);
                            resolve(curLine);
                        }
                    }, 500);
                }
                else {
                    resolve(curLine);
                }
            });
        }
    },
    'グローバル関数一覧取得': {
        type: 'func',
        josi: [],
        pure: true,
        fn: function (sys) {
            const vars = sys.__varslist[1];
            const res = [];
            for (const key of vars.keys()) {
                res.push(key);
            }
            return res;
        }
    },
    'システム関数一覧取得': {
        type: 'func',
        josi: [],
        pure: true,
        fn: function (sys) {
            const vars = sys.__v0;
            const res = [];
            for (const key of vars.keys()) {
                if (key.startsWith('__') || key.startsWith('!') || key === 'meta') {
                    continue;
                }
                res.push(key);
            }
            return res;
        }
    },
    'システム関数存在': {
        type: 'func',
        josi: [['が', 'の']],
        pure: true,
        fn: function (fname, sys) {
            return (typeof sys.__getSysVar(fname) !== 'undefined');
        }
    },
    'プラグイン一覧取得': {
        type: 'func',
        josi: [],
        pure: true,
        fn: function (sys) {
            const a = [];
            for (const f in sys.pluginfiles) {
                a.push(f);
            }
            return a;
        }
    },
    'モジュール一覧取得': {
        type: 'func',
        josi: [],
        pure: true,
        fn: function (sys) {
            const a = [];
            for (const f in sys.__module) {
                a.push(f);
            }
            return a;
        }
    },
    '助詞一覧取得': {
        type: 'func',
        josi: [],
        pure: true,
        asyncFn: false,
        fn: function (sys) {
            return sys.josiList;
        }
    },
    '予約語一覧取得': {
        type: 'func',
        josi: [],
        pure: true,
        asyncFn: false,
        fn: function (sys) {
            return sys.reservedWords;
        }
    },
    // @プラグイン管理
    'プラグイン名': { type: 'const', value: 'メイン' }, // @ぷらぐいんめい
    'プラグイン名設定': {
        type: 'func',
        josi: [['に', 'へ']],
        pure: true,
        fn: function (s, sys) {
            sys.__setSysVar('プラグイン名', s);
        },
        return_none: true
    },
    '名前空間': { type: 'const', value: '' }, // @なまえくうかん
    '名前空間設定': {
        type: 'func',
        josi: [['に', 'へ']],
        pure: true,
        fn: function (s, sys) {
            // push namespace
            sys.__namespaceList.push([sys.__getSysVar('名前空間'), sys.__getSysVar('プラグイン名')]);
            sys.__setSysVar('名前空間', s);
        },
        return_none: true
    },
    '名前空間ポップ': {
        type: 'func',
        josi: [],
        pure: true,
        fn: function (sys) {
            // pop namespace
            const a = sys.__namespaceList.pop();
            if (a) {
                sys.__setSysVar('名前空間', a[0]);
                sys.__setSysVar('プラグイン名', a[1]);
            }
        },
        return_none: true
    }
};
